import createCountdownLock from '../countdown-lock.js';
import createSimpleObserver from '../simple-observer.js';
import enforceObservableRules from '../enforce-rules.js';
const combine = (atoms) => {
    const { notify, observe: observeSimpleObserver } = createSimpleObserver();
    const atomKeys = Object.keys(atoms);
    let countdownLock = createCountdownLock(atomKeys);
    let values = {};
    let subscriptions = [];
    let subscribers = 0;
    const maybeUnsubscribeSourceObservables = () => {
        subscribers -= 1;
        if (subscribers > 0)
            return;
        subscriptions.forEach((unsubscribe) => unsubscribe());
        subscriptions = [];
        values = {};
        countdownLock = createCountdownLock(atomKeys);
    };
    const observe = (callback) => {
        subscribers += 1;
        if (subscribers === 1) {
            subscriptions = Object.entries(atoms).map(([name, atom]) => atom.observe(async (value) => {
                values = {
                    ...values,
                    [name]: value,
                };
                if (countdownLock.unlock(name))
                    await notify(values);
            }));
        }
        const unsubscribe = observeSimpleObserver(callback);
        return () => {
            unsubscribe();
            maybeUnsubscribeSourceObservables();
        };
    };
    const get = async () => {
        return Object.fromEntries(await Promise.all(Object.entries(atoms).map(async ([name, atom]) => [name, await atom.get()])));
    };
    const set = async () => {
        throw new Error('combine does not support method: set');
    };
    return enforceObservableRules({
        get,
        set,
        observe,
    });
};
export default combine;
